import { ErrorContent } from "api/http";

type ApiErrors = Record<string, string[]>;

export const defaultErrorMessage = "Something went wrong.";

export const proccessAPIErrorResponse = (
  error: unknown,
  defaultErrorMessageOverride?: string
) => {
  try {
    if (!isApiError(error)) {
      return defaultErrorMessageOverride ?? "Something went wrong.";
    }

    const errorContent = JSON.parse(error.content);
    const errors =
      "errors" in errorContent ? (errorContent.errors as ApiErrors) : {};
    const errorKvpList = Object.entries(errors);

    for (const [incorrectProperty, [errorDescription]] of errorKvpList) {
      // For type errors the first property is a "request" property without details about the problematic property.
      if (incorrectProperty === "request" || incorrectProperty === "") {
        continue;
      }

      const property = incorrectProperty.replace("$.", "");

      if (errorDescription.includes("The JSON value could not be converted")) {
        return `The property ${property} is of incorrect type.`;
      }

      if (errorDescription.includes("field is required")) {
        return `The property ${property} is required.`;
      }

      if (errorDescription.includes("Invalid Url")) {
        return `The property ${property} has an invalid url.`;
      }
    }

    return defaultErrorMessageOverride ?? defaultErrorMessage;
  } catch (e) {
    return defaultErrorMessageOverride ?? defaultErrorMessage;
  }
};

function isApiError(error: unknown): error is ErrorContent {
  return typeof error === "object" && error !== null && "content" in error;
}
